module.exports = __webpack_public_path__ + "static/media/HOW TO UPDATE A CLIENT FILE.883ad89c.png";